import { useState, useEffect } from "react";

export default function useElementSize(elementRef) {
	const [size, setSize] = useState({ width: 0, height: 0 });

	useEffect(() => {
		const element = elementRef?.current;
		if (element) {
			const updateSize = () => {
				const { width, height } = element.getBoundingClientRect();
				setSize((prev) => {
					// Only update if changed to avoid unnecessary re-renders
					if (prev.width === width && prev.height === height) return prev;
					return { width, height };
				});
			};

			const resizeObserver = new ResizeObserver(() => {
				requestAnimationFrame(updateSize);
			});
			resizeObserver.observe(element);
			updateSize(); // Initial measurement

			return () => {
				resizeObserver.disconnect();
			};
		}
	}, [elementRef]);

	return { ...size };
}
